"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _reactTooltip = _interopRequireDefault(require("react-tooltip")),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _error = require("../../../common/styles/error"),
    _styles = require("../styles");

function ErrorIcon(a) {
  var b = a.className,
      c = a.errorMessage,
      d = a.id,
      e = a.tooltipProps,
      f = b ? (0, _defineProperty2["default"])({}, b, !c) : void 0,
      g = _react["default"].createElement(_Icon["default"], {
    color: "thunder-bird",
    className: (0, _classnames["default"])(f, _error.icon),
    name: "alert",
    size: 15
  });

  return c ? _react["default"].createElement("div", {
    "data-tip": !0,
    "data-for": d,
    className: (0, _classnames["default"])(b, _styles.errorIconStyles)
  }, _react["default"].createElement(_reactTooltip["default"], (0, _extends2["default"])({
    id: d,
    className: _styles.errorTooltipStyles,
    effect: "solid",
    place: "right",
    type: "error"
  }, e), _react["default"].createElement("span", null, c)), g) : g;
}

ErrorIcon.defaultProps = {
  className: void 0,
  errorMessage: void 0,
  tooltipProps: {}
};

var _default = (0, _react.memo)(ErrorIcon);

exports["default"] = _default;